<template>
	<div
		class="mb-4 flex items-center justify-between pt-4 pl-lg text-3xl"
		:class="{
			'sticky top-0 z-10': sticky,
		}"
	>
		<v-h4>
			<slot></slot>
		</v-h4>

		<button
			type="button"
			class="px-10 py-5 text-right outline-hidden"
			@click="$emit('close')"
		>
			<v-icon icon="close" class="text-xl" />
		</button>
	</div>
</template>

<script lang="ts" setup>
defineProps<{
	sticky?: boolean;
}>();

defineEmits<{
	(event: "close"): void;
}>();
</script>
